var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 57,
    viewBox: "0 0 84 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2393_4965",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 57
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H84V57H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2393_4965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.2053 27.0224L69.504 10.527C68.863 9.7547 67.9221 9.31194 66.9236 9.31194H54.5946V3.39688C54.5946 1.52789 53.0846 0.0078125 51.2283 0.0078125H3.35749C1.50217 0.0078125 -0.0078125 1.52789 -0.0078125 3.39688V45.6929C-0.0078125 47.5619 1.50217 49.082 3.35749 49.082H10.1276C10.6198 53.5167 14.3628 56.9752 18.8948 56.9752C23.4268 56.9752 27.1688 53.5167 27.662 49.082H51.2283C51.842 49.082 52.4152 48.9136 52.9104 48.6239C53.4047 48.9126 53.9768 49.0809 54.5885 49.0809H58.839C59.3312 53.5157 63.0742 56.9752 67.6072 56.9752C72.1392 56.9752 75.8822 53.5157 76.3744 49.0809H80.6248C82.4802 49.0809 83.9891 47.5598 83.9891 45.6919V29.1964C83.9891 28.4017 83.7106 27.6284 83.2053 27.0224ZM3.35749 3.40198L51.2242 3.39688L51.2253 12.6806C51.2253 12.6877 51.2242 12.6939 51.2242 12.701V45.6878H27.3886C26.3465 41.9498 22.9346 39.2004 18.8948 39.2004C14.855 39.2004 11.4421 41.9508 10.4 45.6888L3.36256 45.6929L3.35749 3.40198ZM18.8948 53.581C15.887 53.581 13.4413 51.1172 13.4413 48.0883C13.4413 45.0594 15.887 42.5946 18.8948 42.5946C21.9016 42.5946 24.3484 45.0594 24.3484 48.0883C24.3484 51.1172 21.9016 53.581 18.8948 53.581ZM67.6072 53.581C64.5994 53.581 62.1526 51.1172 62.1526 48.0883C62.1526 45.0594 64.5994 42.5946 67.6072 42.5946C70.614 42.5946 73.0608 45.0594 73.0608 48.0883C73.0608 51.1172 70.614 53.581 67.6072 53.581ZM76.101 45.6858C75.0579 41.9488 71.646 39.2004 67.6072 39.2004C63.5674 39.2004 60.1555 41.9498 59.1124 45.6878L54.5946 45.6919V12.7061L66.9185 12.7051L80.6188 29.1964L80.6248 45.6858H76.101Z",
    fill: "#EC7C40"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6389 16.4498C66.3189 16.0642 65.8469 15.8418 65.3487 15.8418H57.9497C57.021 15.8418 56.2695 16.5988 56.2695 17.5333V25.9927C56.2695 26.9272 57.021 27.6842 57.9497 27.6842H72.3466C73.7705 27.6842 74.5483 26.011 73.6369 24.9092L66.6389 16.4498Z",
    fill: "#EC7C40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckOrange);
export default __webpack_public_path__ + "static/media/truck_orange.75621ae9e34e9e1e99984a096dcff4bf.svg";
export { ForwardRef as ReactComponent };